/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect, useCallback } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { debounce } from 'lodash';
import Input from './Input';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';
import ModalHalf from '@components/modal/ModalHalf';
import FormOverlay from '@components/form/common/FormOverlay';
import FormInputVariant from '@components/form/common/FormInputVariant';
import FormArrow from '@components/form/common/FormArrow';
import { Loader } from '@components/screen/Layout';
import Button from '@components/form/Button';

import { getAttibutes, isVn } from '@global/helpers';
import { isWeb } from '@global/screens';
import { INPUT_HEIGHT } from '@/constants';
import Colors from '@global/colors';

import PropTypes from 'prop-types';

const propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string,
    PropTypes.number,
  ]),
  editable: PropTypes.bool,
  hideLabel: PropTypes.bool,
  filterId: PropTypes.array,
  basedOnFilterId: PropTypes.bool,
  compareProducts: PropTypes.array,
  showVariant: PropTypes.bool,
  customFilter: PropTypes.object,
  bypassDefaultCombination: PropTypes.bool,
  searchBrand: PropTypes.bool,
  isButton: PropTypes.bool,
};

const defaultProps = {
  value: '',
  editable: true,
  hideLabel: false,
  filterId: [],
  basedOnFilterId: false,
  compareProducts: [],
  showVariant: true,
  customFilter: {},
  bypassDefaultCombination: false,
  searchBrand: false,
  isButton: false,
};

const defaultPhoto = require('@/assets/img/default/image-default.png');

const limit = 10;

import useApi from '@/hooks/useApi';
import { MsCatalog } from '@api/ms-catalog';
import { MsB2b } from '@api/ms-b2b';

const SelectProductV2 = (props) => {
  const {
    value = '',
    editable = true,
    hideLabel = false,
    filterId = [],
    basedOnFilterId = false,
    compareProducts = [],
    priceRulesId = '',
    showVariant = true,
    customFilter = {},
    bypassDefaultCombination = false,
    searchBrand,
    isButton,
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPagination, setIsLoadingPagination] = useState(false);
  const [skip, setSkip] = useState(0);
  const [keyword, setKeyword] = useState('');
  const [showModalProduct, setShowModalProduct] = useState(false);
  const [showCombination, setShowCombination] = useState(false);
  const [combinationList, setCombinationList] = useState([]);
  const [newOptions, setNewOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [formValue, setFormValue] = useState('');

  const getProducts = useApi(MsCatalog.getProducts);
  const getBrands = useApi(MsCatalog.getBrands);
  const getProductsFromEs = useApi(MsB2b.getProductsFromEs);
  const getProductSearch = useApi(MsB2b.getProductSearch);

  useEffect(() => {
    let mounted = true;
    if (mounted && value) {
      setInputValue(value);
      setFormValue(value && Object.keys(value).length ? value.name : '');
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  useEffect(() => {
    if (showModalProduct === true) {
      setSkip(0);
      setCombinationList([]);
      setKeyword('');
      onSearch();
    }
  }, [showModalProduct]);

  // on search product
  const onSearch = async (val, newSkip = 0) => {
    setSkip(newSkip);
    if (newSkip) {
      setIsLoadingPagination(true);
    } else {
      setIsLoading(true);
    }
    try {
      const filter = {
        ...(isVn()
          ? {
              is_active_in_b2b_vn: true,
            }
          : {
              is_active_in_b2b: true,
            }),
        ...(customFilter && Object.keys(customFilter).length
          ? customFilter
          : {}),
      };

      if (searchBrand) {
        const response = await getBrands.request({
          params: {
            filter: val ? { keyword: val } : {},
            skip: newSkip,
            limit: limit,
            fields: '_id name',
          },
        });

        if (response.status === 200 && response?.data?.data?.length) {
          let finalData = response.data.data.map((brand) => ({
            id: brand._id,
            name: brand.name,
          }));
          if (newSkip) {
            finalData = newOptions.concat(finalData);
          }
          setNewOptions(finalData);
        } else {
          setNewOptions(newSkip ? newOptions : []);
        }

        if (newSkip) {
          setIsLoadingPagination(false);
        } else {
          setIsLoading(false);
        }
        return; // stop di sini biar ga lanjut ke product search
      }
      if (filterId && filterId.length) {
        filter.id = { $in: filterId };
      }
      if (priceRulesId) {
        delete filter['is_active_in_b2b'];
        delete filter['is_active_in_b2b_vn'];
      }
      if (val) {
        filter['keyword'] = val;
        if (priceRulesId) {
          filter['pricelist_id'] = priceRulesId;
        }
      }
      if (basedOnFilterId ? filterId && filterId.length : true) {
        let response = null;

        if (val) {
          if (priceRulesId) {
            response = await getProductSearch.request('product-price-rules', {
              params: {
                filter: filter,
                skip: newSkip,
                limit: limit,
              },
            });
          } else {
            response = await getProductsFromEs.request({
              params: {
                filter: filter,
                skip: newSkip,
                limit: limit,
              },
            });
          }
        } else {
          if (priceRulesId) {
            response = await MsCatalog.getPriceRulesProduct(
              {
                params: {
                  filter: filter,
                  skip: newSkip,
                  limit: limit,
                },
              },
              priceRulesId,
            );
          } else {
            response = await getProducts.request({
              params: {
                filter: filter,
                skip: newSkip,
                limit: limit,
              },
            });
          }
        }

        if (response.status == 200 && response?.data?.data?.length) {
          let finalData = response.data.data
            .map((item) => {
              if (
                priceRulesId &&
                item.product_combination_id &&
                item.final_price
              ) {
                item.combinations = [
                  {
                    ...(isVn()
                      ? {
                          is_active_in_b2b_vn: true,
                        }
                      : {
                          is_active_in_b2b: true,
                        }),
                    reference: item.reference,
                    variant: item.variant,
                    price: Number(item.final_price),
                    images: [
                      {
                        url: item.image,
                        is_cover: true,
                      },
                    ],
                    _id: item.product_combination_id,
                  },
                ];
                item.default_combination = item.combinations[0];
              }
              if (item?.default_category?.id) {
                item.category = item.default_category;
              }
              item.combinations = (item.combinations || []).filter((com) =>
                isVn() ? com.is_active_in_b2b_vn : com.is_active_in_b2b,
              );
              item.combination_name = item.combinations?.length
                ? item.combinations
                    .map((com) => getAttibutes(com.attributes))
                    .join(', ')
                : '-';
              if (item.combinations?.length) {
                item.combinations = item.combinations.map((com) => {
                  if (!com.variant) {
                    com.variant = getAttibutes(com.attributes);
                  }
                  return com;
                });
              }
              if (priceRulesId && item.variant) {
                item.combination_name = item.variant;
              }
              // if has compare product props
              // if (compareProducts?.length) {
              //     const findData = compareProducts.find(pr => pr.id == item.id)
              //     if (findData) {
              //         item.combinations = item.combinations.filter(cb => cb._id == findData.combination_id)
              //         item.combination_name = item.combinations?.length ? item.combinations.map(com => getAttibutes(com.attributes)).join(', ') : '-'
              //     }
              // }
              if (item.combinations.length == 1) {
                item.default_combination = item.combinations[0];
              }
              if (bypassDefaultCombination) {
                const defaultCombination = item.combinations[0];
                const defaultImage = defaultCombination.images.find(
                  (i) => i.is_cover,
                );
                item.image = defaultImage?.url;
              }
              return item;
            })
            .filter((item) => item.combinations?.length > 0);
          if (newSkip) {
            finalData = newOptions.concat(finalData);
          }
          setNewOptions(finalData);
        } else {
          let finalData = [];
          if (newSkip) {
            finalData = newOptions.concat(finalData);
          }
          setNewOptions(finalData);
        }
      } else {
        setNewOptions([]);
      }
      if (newSkip) {
        setIsLoadingPagination(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      if (newSkip) {
        setIsLoadingPagination(false);
      } else {
        setIsLoading(false);
      }
    }
  };

  const onSearchInput = useCallback(
    debounce((val) => onSearch(val), 250),
    [],
  );

  // convert combination value
  const convertCombination = (com) => {
    let result = {};

    if (com && Object.keys(com).length) {
      result = {
        _id: com._id,
        id: com._id,
        attributes: com.attributes,
        ean_no: com.ean_no,
        reference: com.reference,
        price: com.price,
        price_after_discount: com.price_after_discount
          ? com.price_after_discount
          : com.price,
        stock: com.stock,
        variant: com.variant ? com.variant : getAttibutes(com.attributes),
        images: com.images || [],
      };
    }

    return result;
  };

  // handling selecting product
  const onSelectProduct = (item) => {
    // if have compare product props
    if (compareProducts?.length) {
      const findData = compareProducts.filter((pr) => pr.id == item.id);
      if (findData?.length) {
        item.combinations = item.combinations
          .filter(
            (cb) => findData.findIndex((a) => a.combination_id == cb._id) > -1,
          )
          .map((cb) => {
            const match = findData.find((a) => a.combination_id == cb._id);
            if (match) {
              cb.price = match.price;
              cb.price_after_discount = match.price;
              cb.reference = match?.reference ? match.reference : cb.reference;
            }
            return cb;
          });
      }
    }
    if (item?.combinations?.length > 1) {
      // if the product selected have more than one combination then open combination picker
      const finalValue = {
        id: item.id,
        category: item.category || { id: '', name: '' },
        brand: item.brand,
        name: item.name,
        description: item.description || '',
        how_to_use: item.how_to_use || '',
        ingredients: item.ingredients || '',
        combination: {},
        vat: item.vat,
      };
      setInputValue(finalValue);
      setCombinationList(item.combinations);
      setShowCombination(true);
    } else if (
      item?.combinations?.length == 1 &&
      item.default_combination &&
      Object.keys(item.default_combination).length
    ) {
      // if the product selected have only one combination then close the product picker
      const finalValue = {
        id: item.id,
        category: item.category || { id: '', name: '' },
        brand: item.brand,
        name: item.name,
        description: item.description || '',
        how_to_use: item.how_to_use || '',
        ingredients: item.ingredients || '',
        combination: convertCombination(
          item?.combinations?.length == 1
            ? item?.combinations[0]
            : item.default_combination,
        ),
        vat: item.vat,
      };
      setFormValue(finalValue.name);
      setInputValue(finalValue);
      try {
        setShowModalProduct(false);
        props.onChange(finalValue);
      } catch (error) {}
    }
  };

  // handling selecting combination
  const onSelectCombination = (item) => {
    const finalValue = {
      ...inputValue,
      combination: item,
    };
    setFormValue(finalValue.name);
    setInputValue(finalValue);
    setCombinationList([]);
    setShowCombination(false);
    setShowModalProduct(false);
    props.onChange(finalValue); // product and combination selected callback
  };

  // check value of shade combination
  const isHex = (value) => {
    if (value) {
      return /^#[0-9A-F]{6}$/i.test(value);
    }
    return false;
  };

  // product item
  const OptionItem = ({ item, index }) => {
    if (searchBrand) {
      return (
        <TouchableOpacity
          onPress={() => {
            setFormValue(item.name);
            setInputValue(item);
            setShowModalProduct(false);
            props.onChange(item);
          }}
          key={'list-brand-' + index}
          style={styles.productItem}>
          <SociollaText type="medium" style={styles.productChildName}>
            {item.name}
          </SociollaText>
        </TouchableOpacity>
      );
    }

    return (
      <TouchableOpacity
        onPress={() => onSelectProduct(item)}
        key={'list-product-' + index}
        style={styles.productItem}>
        <View style={styles.productContainer}>
          <View style={styles.imageContainer}>
            <Image
              source={{ uri: `${item.image ? item.image : defaultPhoto}` }}
              style={{ width: 36, height: 36 }}
              width={36}
              height={36}
            />
          </View>
          <View style={{ width: '80%' }}>
            <SociollaText type="medium" style={styles.productName}>
              {item?.brand?.name ? item.brand.name.toUpperCase() : '-'}
            </SociollaText>
            <SociollaText type="medium" style={styles.productChildName}>
              {item.name}
            </SociollaText>
            <SociollaText
              style={item.combination_name ? { paddingBottom: 8 } : {}}>
              {item.reference}
            </SociollaText>
            {item.combination_name ? (
              <SociollaText style={styles.combinationName}>
                {item.combination_name}
              </SociollaText>
            ) : (
              false
            )}
          </View>
        </View>
      </TouchableOpacity>
    );
  };

  // combination item
  const OptionCombinationItem = ({ item, index }) => {
    const result = [];
    // if combination is shade
    if (item.attributes.shade && Object.keys(item.attributes.shade).length) {
      result.push(
        <View style={styles.shadeContainer} key={`shade-combination-${index}`}>
          <View style={{ marginRight: 10 }}>
            {item.attributes.shade.value ? (
              isHex(item.attributes.shade.value) ? (
                <View
                  style={[
                    styles.shadeStyle,
                    { backgroundColor: item.attributes.shade.value },
                  ]}></View>
              ) : item.attributes.shade.value.indexOf('http') > -1 ? (
                <View style={[styles.shadeStyle, styles.shadeFirst]}>
                  <Image
                    style={styles.shadeStyle}
                    width={18}
                    height={18}
                    source={item.attributes.shade.value}
                  />
                </View>
              ) : (
                <View style={[styles.shadeStyle, styles.shadeDefault]}></View>
              )
            ) : (
              <View style={[styles.shadeStyle, styles.shadeDefault]}></View>
            )}
          </View>
          <SociollaText style={styles.combinationText}>
            {item.attributes.shade.name}
          </SociollaText>
        </View>,
      );
    }

    // if combination is size
    if (item.attributes.size && Object.keys(item.attributes.size).length) {
      result.push(
        <>
          {result.length ? (
            <SociollaText
              style={styles.combinationText}
              key={`size-top-combination-${index}`}>
              ,{' '}
            </SociollaText>
          ) : (
            false
          )}
          <SociollaText
            style={styles.combinationText}
            key={`size-combination-${index}`}>
            {item.attributes.size.name}
          </SociollaText>
        </>,
      );
    }

    // if combination is variant
    if (
      item.attributes.variant &&
      Object.keys(item.attributes.variant).length
    ) {
      result.push(
        <>
          {result.length ? (
            <SociollaText
              style={styles.combinationText}
              key={`variant-top-combination-${index}`}>
              ,{' '}
            </SociollaText>
          ) : (
            false
          )}
          <SociollaText
            style={styles.combinationText}
            key={`variant-combination-${index}`}>
            {item.attributes.variant.name}
          </SociollaText>
        </>,
      );
    }

    // if have no attribute
    if (!result.length) {
      result.push(
        <SociollaText key={`no-combination-${index}`}>
          No attribute
        </SociollaText>,
      );
    }

    return result;
  };

  return (
    <>
      <View style={{ position: 'relative' }}>
        <FormOverlay
          {...props}
          onCallback={() =>
            editable ? setShowModalProduct(!showModalProduct) : false
          }
        />
        {/* Start Input Container */}
        {isButton ? (
          <Button
            rounded
            buttonStyle={{ width: 120 }}
            title={
              <SociollaText
                type="bold"
                style={{
                  fontSize: 12,
                  letterSpacing: 0.5,
                  color: Colors.white,
                }}>
                {props.label || 'Select'}
              </SociollaText>
            }
            onPress={() => editable && setShowModalProduct(true)}
          />
        ) : (
          <Input
            {...props}
            label={hideLabel ? '' : props.label}
            inputContainerStyle={{ height: INPUT_HEIGHT }}
            value={formValue}
            rightIcon={<FormArrow {...props} />}
          />
        )}
        {/* End Input Container */}
        {/* Start Result Container */}
        {showVariant &&
        inputValue &&
        inputValue.combination &&
        Object.keys(inputValue.combination).length ? (
          <FormInputVariant {...props} inputValue={inputValue} />
        ) : (
          false
        )}
        {/* End Result Container */}
      </View>
      {/* Start Popup Product Picker */}
      <ModalHalf
        title={props.label}
        visible={showModalProduct}
        onClose={() => setShowModalProduct(false)}
        maxWidth={isWeb ? 450 : '100%'}
        spaceFromTop={isWeb ? '10%' : false}
        headerBordered={true}
        searchInput={
          <View style={styles.productPicker}>
            <Input
              label=""
              placeholder="Search something here..."
              value={keyword}
              onChangeText={(val) => {
                setKeyword(val);
                onSearchInput(val);
              }}
              rightIcon={
                <Image
                  style={{ width: 16, height: 16 }}
                  width={16}
                  height={16}
                  svg={true}
                  source={require('@assets/img/icons/search.svg')}
                />
              }
            />
          </View>
        }>
        {isLoading ? (
          <Loader />
        ) : !(newOptions || []).length ? (
          <View style={styles.noData}>
            <SociollaText style={styles.combinationText}>
              No data found
            </SociollaText>
          </View>
        ) : (
          (newOptions || []).map((item, idx) => (
            <OptionItem key={idx} index={idx} item={item} />
          ))
        )}
        {(filterId?.length ? filterId : newOptions)?.length >= limit &&
        (filterId?.length ? filterId : newOptions)?.length >= skip &&
        !isLoading ? (
          isLoadingPagination ? (
            <Loader />
          ) : (
            <View style={styles.loadMoreButton}>
              <TouchableOpacity
                style={[styles.noData, styles.loadMorePadding]}
                onPress={() => onSearch(keyword, skip + limit)}>
                <SociollaText>Load More</SociollaText>
              </TouchableOpacity>
            </View>
          )
        ) : (
          false
        )}
        {/* Start Combination Picker */}
        <ModalHalf
          title={`Select Combination`}
          visible={showCombination}
          onClose={() => setShowCombination(false)}
          maxWidth={isWeb ? 400 : '100%'}
          spaceFromTop={isWeb ? '10%' : false}
          headerBordered={true}>
          {combinationList?.length ? (
            combinationList.map((item, idx) => (
              <TouchableOpacity
                onPress={() => onSelectCombination(item)}
                activeOpacity={0.6}
                style={[
                  {
                    borderBottomColor:
                      idx == combinationList.length - 1
                        ? Colors.white
                        : Colors.grey0,
                  },
                  styles.combinationItem,
                ]}
                key={`combination-${idx}`}>
                <OptionCombinationItem
                  item={item}
                  index={`combination-child-${idx}`}
                  key={`combination-item-${idx}`}
                />
              </TouchableOpacity>
            ))
          ) : (
            <View style={styles.noData}>
              <SociollaText style={styles.combinationText}>
                No combinations found
              </SociollaText>
            </View>
          )}
        </ModalHalf>
        {/* End Combination Picker */}
      </ModalHalf>
      {/* End Popup Product Picker */}
    </>
  );
};

const styles = StyleSheet.create({
  noData: {
    width: '100%',
    paddingHorizontal: 15,
    paddingVertical: 25,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  combinationText: { fontSize: 13 },
  shadeContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  shadeStyle: { width: 19, height: 19, borderRadius: 22 },
  shadeFirst: { backgroundColor: Colors.white, overflow: 'hidden' },
  shadeDefault: {
    backgroundColor: Colors.white,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: Colors.grey0,
  },
  productPicker: {
    width: '100%',
    paddingHorizontal: 15,
    paddingVertical: 10,
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
  },
  loadMoreButton: {
    width: '100%',
    borderTopColor: Colors.grey0,
    borderTopWidth: 1,
  },
  loadMorePadding: { paddingBottom: 10, paddingTop: 20 },
  combinationItem: {
    width: '100%',
    borderBottomWidth: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingVertical: 16,
  },
  productItem: {
    width: '100%',
    padding: 15,
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
  },
  productContainer: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
  },
  imageContainer: {
    width: '20%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  productName: { fontSize: 12, color: Colors.black1, paddingBottom: 8 },
  productChildName: {
    fontSize: 14,
    color: Colors.black1,
    paddingBottom: 0,
  },
  combinationName: { fontSize: 12, color: Colors.black5 },
});

SelectProductV2.propTypes = propTypes;
SelectProductV2.defaultProps = defaultProps;

export default React.memo(SelectProductV2, (prev, next) => prev == next);
